import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { triggerEnhancedWebviewFeature, isBFIslandWebview } from '@buzzfeed/bf-utils/lib/webview';
import { useViewImpression } from '../../hooks';
import { CreateIcon } from '../../icons/Icons';
import styles from './Card.module.scss';

const Card = ({ item, index, onClick }) => {
  const router = useRouter();
  const [isWebview, setIsWebview] = useState(false);

  const contentObjectId = item?.id;
  const itemType = item?.object_type?.name || 'bfp_content';

  const imageUrl =
    item?.content?.bfp?.data?.intro?.card?.backgroundImage?.url ||
    item?.content?.bfp?.data?.promo?.card?.image_url ||
    '';

  const title =
    item?.content?.bfp?.data?.intro?.card?.actionTitle ||
    item?.title ||
    item?.content?.bfp?.data?.intro?.card?.title ||
    item?.content?.bfp?.data?.intro?.card?.headline ||
    `Generator ${item?.id ?? index}`;

  const creationCount =
    item?.content?.comments?.by_type?.ai_generation?.count || 0;

  const trackingData = {
    unit_type: 'section',
    unit_name: 'generators_carousel',
    item_type: 'card',
    item_name: contentObjectId,
    position_in_unit: index,
    target_content_type: 'widget',
    target_content_id: contentObjectId,
  };

  const { setObservable } = useViewImpression({
    trackingData,
  });

  useEffect(() => {
    setIsWebview(isBFIslandWebview());
  }, []);

  const getFormattedCount = (count) => {
    if (count > 999) {
      return `${(count / 1000).toFixed(0)}k`;
    }
    return count;
  };

  const handleClick = () => {
    onClick?.();

    if (isWebview) {
      triggerEnhancedWebviewFeature({
        feature: 'navigate',
        params: {
          path: `/webview/feed/content-objects/${itemType}/${contentObjectId}`,
          queryParams: {
            source: 'page',
            type: 'creation',
          },
        },
        version: 1,
      });
    } else {
      // Navigate to web generator page
      router.push(`/content-objects/${itemType}/${contentObjectId}`);
    }
  };

  return (
    <div
      className={styles.card}
      ref={(el) => setObservable(el)}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      aria-label={title}
    >
      {imageUrl && (
        <div className={styles.imageContainer}>
          <img
            src={imageUrl}
            alt=""
            className={styles.image}
            loading="lazy"
          />
          <div className={styles.overlay} />
          <div className={styles.badge}>
            <span className={styles.createIcon}>
              <CreateIcon />
            </span>
            <span className={styles.count}>{getFormattedCount(creationCount)}</span>
          </div>
        </div>
      )}
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
};

export default Card;
